export default __webpack_public_path__ + "static/media/gallery_test(8).33f4968b.png";